import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Container, Typography, Link, Button,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { isAuthorized } from '../../services/auth';
import { Link as LinkTo } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
}));

function Offline() {
  const classes = useStyles();
  return (
    <Container className={classes.main}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs spacing={4} display="flex" flexDirection="column" gap={2}>
          <Typography variant="h3">Ops... Você está sem internet! :(</Typography>
          <Typography variant="h6">Contacte seu provedor e tente novamente mais tarde.</Typography>
          {/* <Button variant="contained" onClick={() => window.location.reload()}>
            Tentar novamente
          </Button> */}
        </Grid>
      </Grid>
    </Container>
  );
}

export default Offline;
